export default {
  FORMAT_DATE: 'MM/DD/YYYY',
  FORMAT_TIME: 'hh:mm:ss',
  FORMAT_HOURS: 'HH:mm',
  FORMAT_DATETIME: 'MM/DD/YYYY hh:mm:ss',
  FORMAT_DAY_AND_DATE: 'dddd, D MMMM',
  FORMAT_TOURNAMENT_START: 'D MMM YYYY, hh:mm',
	FORMAT_MONTH_DAY_YEAR: 'MMMM D, YYYY'
}
